<template>
<div class="chapter">
<div class="inner_page">
<p class="bkt" id="d7e91"><b>REVELATION REVEALED </b><br/><span class="small"><i>A Verse-by-Verse Study </i></span></p>
<p class="tx" id="d7e191a"><br/><br/><br/></p>
<p class="au" id="d7e191"><span class="small">BY DR. JACK VAN IMPE</span></p>
<p class="default" id="d7e19113"><br/><br/><br/></p>
<p class="ser"><img alt="RevelationRevealed_0001_001" id="d14e41" src="images/RevelationRevealed_0001_001.jpg" style="max-width:100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Impe_ISBN9781418517243_epub_c1_r1.vue?13706be8